import { useTranslation } from 'react-i18next'

export default function LiveBadge({ size = 'md' }) {
  const { t } = useTranslation()
  const sm = size === 'sm'
  return (
    <span
      className={`flex items-center gap-1.5 rounded-full bg-live font-extrabold text-white ${
        sm ? 'px-2.5 py-[3px] text-xs' : 'px-3 py-1.5 text-[13px]'
      }`}
    >
      <span className={`up-dot-white rounded-full bg-white ${sm ? 'size-1.5' : 'size-2'}`} />
      {t('common.live')}
    </span>
  )
}
